import React, { Component, Fragment } from 'react'
import { Query } from 'react-apollo'

import { CATEGORIES_QUERY, SELF_QUERY } from '../../queries'

import helpers from '../../helpers'

import { FilterContainer } from './styles'
import { Container } from '../../styles/defaults'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import ProductGrid from '../../containers/ProductGrid'
import Filter from '../../components/Filter'
import SearchInput from '../../components/SearchInput/'
import Loader from '../../components/Loader'
import Error from '../../components/Error'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import coffee from '../../assets/hero/assortiment/koffie.jpg'
import thee from '../../assets/hero/assortiment/thee.jpg'
import nonfood from '../../assets/hero/assortiment/nonfood.jpg'
import food from '../../assets/hero/assortiment/food.jpg'

class Assortiment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: '',
      filteredProducts: [],
      query: ''
    }
  }

  handleClick(e) {
    this.setState({ filter: e.currentTarget.dataset.value, query: '' })
  }

  handleSelectClick(e) {
    this.setState({ filter: e.target.value, query: '' })
  }

  onSearch(e, products) {
    let query = e.target.value.trim().toLowerCase()
    let queryLength = e.target.value.length
    this.setState({ query: e.target.value })
    let allProducts = []
    Object.keys(products).map((key, index) => {
      allProducts = allProducts.concat(products[key].products)
      return null
    })

    const filterExists = Object.keys(products).find(product => this.state.filter === product)
    const filter = filterExists !== undefined ? this.state.filter : ''

    products = filter === '' ? allProducts : products[filter].products
    const result =
      queryLength === 0
        ? []
        : products.filter(
            product =>
              product.firstDescription.toLowerCase().slice(0, queryLength) === query ||
              product.firstDescription.toLowerCase().indexOf(query) !== -1 ||
              product.productCode.toLowerCase().slice(0, queryLength) === query
          )
    if (result.length > 0) {
      this.setState({ filteredProducts: result })
    } else {
      this.setState({ filteredProducts: [] })
    }
  }

  getHero() {
    return this.props.product === 'Koffie'
      ? coffee
      : this.props.product === 'Thee'
      ? thee
      : this.props.product === 'Non-food'
      ? nonfood
      : this.props.product === 'Food'
      ? food
      : null
  }

  render() {
    const hero = this.getHero()

    return (
      <Fragment>
        <Hero
          small={hero}
          medium={hero}
          large={hero}
          retina={hero}
          title={this.props.product}
        />
        <Breadcrumb title={this.props.product} />
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from="25%" to="50%" fixed />
            if (error) return <Error error="de gebruikersgegevens" />
            const { self } = data
            let viewAssortiment =
              self.permissions.includes("VIEW_ASSORTIMENT") ||
              self.role === "MANAGER"
            let editOrder =
              self.permissions.includes("EDIT_ORDER") ||
              self.role === "MANAGER"
            if (!viewAssortiment) {
              return (
                <Container mt mb>
                  Onvoldoende rechten om het assortiment te bekijken
                </Container>
              )
            }
            return (
              <Query query={CATEGORIES_QUERY}>
                {({ loading, error, data }) => {
                  if (loading) return <Loader from="50%" to="75%" fixed />
                  if (error) return <Error error="de producten" />

                  const { categories } = data
                  const filteredProducts = helpers.filterProducts(categories)

                  const products = filteredProducts[this.props.product]

                  // Reset filter on route change
                  const filterExists = Object.keys(products).find(
                    product => this.state.filter === product
                  )
                  const filter =
                    filterExists !== undefined ? this.state.filter : ""

                  return (
                    <Fragment>
                      <FilterContainer mt ac>
                        <Filter
                          products={products}
                          filter={filter}
                          product={this.props.product}
                          handleClick={this.handleClick.bind(this)}
                          handleSelectClick={this.handleSelectClick.bind(this)}
                          categories={Object.keys(products).length > 1}
                        />
                        <SearchInput
                          products={products}
                          onSearch={this.onSearch.bind(this)}
                          query={this.state.query}
                          placeholder="Product zoeken"
                          large
                        />
                      </FilterContainer>
                      {this.state.filteredProducts.length > 0 &&
                      this.state.query !== "" ? (
                        <ProductGrid {...this.props} editOrder={editOrder} products={this.state.filteredProducts} search />
                      ) : (
                        <Fragment>
                          {this.state.filteredProducts.length === 0 &&
                          this.state.query !== "" ? (
                            <Container mt mb>
                              Geen resultaten gevonden...
                            </Container>
                          ) : (
                            <Fragment>
                              {Object.keys(products).length > 1 ? (
                                <Fragment>
                                  {filter === "" ? (
                                    <Fragment>
                                      {Object.keys(products).map(
                                        (key, index) => (
                                          <ProductGrid
                                            key={index}
                                            title={key}
                                            description={
                                              products[key].description
                                            }
                                            image={products[key].image}
                                            products={products[key].products}
                                            editOrder={editOrder}
                                            {...this.props}
                                          />
                                        )
                                      )}
                                    </Fragment>
                                  ) : (
                                    <ProductGrid
                                      title={filter}
                                      image={products[filter].image}
                                      description={products[filter].description}
                                      products={products[filter].products}
                                      editOrder={editOrder}
                                      {...this.props}
                                    />
                                  )}
                                </Fragment>
                              ) : (
                                <Fragment>
                                  {Object.keys(products).map((key, index) => (
                                    <ProductGrid
                                      key={index}
                                      title={key}
                                      description={products[key].description}
                                      image={products[key].image}
                                      products={products[key].products}
                                      editOrder={editOrder}
                                      {...this.props}
                                    />
                                  ))}
                                </Fragment>
                              )}
                            </Fragment>
                          )}
                        </Fragment>
                      )}
                    </Fragment>
                  )
                }}
              </Query>
            )
          }}
        </Query>
      </Fragment>
    )
  }
}

export default withHeaderFooter(Assortiment)



// WEBPACK FOOTER //
// ./src/views/Assortiment/index.js